import React, { useCallback } from 'react';
import { texts } from 'utils/languages/fr';
import { ErrorMessage, RadioLabel } from 'components';
import { RadioGroup, Typography } from '@mui/material';

const SubscriberDeclarationForm = ({ ownAccountAgreement, onChange, errors, isReadOnly }) => {
    const handleChange = useCallback(
        e => {
            const name = e.target.name;
            const value = e.target.value;
            onChange(name, value);
        },
        [onChange]
    );

    return (
        <React.Fragment>
            <Typography align="left" variant="body1" gutterBottom>
                {texts.SOUBSCRIBER_DECLARATION}
            </Typography>
            <RadioGroup
                name="ownAccountAgreement"
                value={ownAccountAgreement}
                onChange={handleChange}
            >
                <RadioLabel
                    disabled={isReadOnly}
                    value="yes"
                    label={texts.SOUBSCRIBER_DECLARATION_OPT1}
                />
                <RadioLabel
                    value="no"
                    disabled={isReadOnly}
                    label={`${texts.SOUBSCRIBER_DECLARATION_OPT2} ${texts.SOUBSCRIBER_DECLARATION_OPT2_I} ${texts.SOUBSCRIBER_DECLARATION_OPT2_II} ${texts.SOUBSCRIBER_DECLARATION_OPT2_III} ${texts.SOUBSCRIBER_DECLARATION_OPT2_IV}`}
                />
            </RadioGroup>
            {!!errors?.ownAccountAgreement && (
                <ErrorMessage gutterBottom message={errors?.ownAccountAgreement} />
            )}
        </React.Fragment>
    );
};

export default SubscriberDeclarationForm;
